import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { DataSharingService } from '../../../core/data-sharing/data-sharing.service';
import { PodcastGroup, Podcast } from '../../../data/podcast-client-api/model/podcastContent';
import { Subscription } from 'rxjs';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { PodcastDataRestService } from '../../../data/podcast/podcast-data-rest.service';

@Component({
  selector: 'app-podcast-grid',
  templateUrl: './podcast-grid.component.html',
  styleUrls: ['./podcast-grid.component.css']
})
export class PodcastGridComponent implements OnInit, OnDestroy {

  // podcastGroup: PodcastGroup = null;
  podcasts: Podcast[] = [];
  isDesktop: boolean;
  @Input() podcastGroup: PodcastGroup;
  routerSubs: Subscription;
  podcastGroupID: number;
  isBlog: boolean = false;

  constructor(
    private deviceService: DeviceDetectorService,
    private podcastService: PodcastDataRestService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.isDesktop = this.deviceService.isDesktop();



    this.routerSubs = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url.includes('podcastGrid')) {
          this.getPodcatGroup();
        }
      }
    });



  }

  ngOnInit() {


    if (this.router.url.includes('podcastGrid')) {
      var marginTop: string;
      if (this.isDesktop) {
        marginTop = "80px"
      }
      else {
        marginTop = "50px"
      }
      document.getElementById('pageHeader').style.marginTop = marginTop;
    }

    if (!this.podcastGroup) {
      this.getPodcatGroup();
    }
    else {
      this.podcasts = this.podcastGroup.podcastPS;
    }
  }

  getPodcatGroup() {
    this.podcastGroupID = +this.route.snapshot.paramMap.get('id');
    this.isBlog = this.podcastGroupID == 228;
    this.podcastService.getPodcastGroupById(this.podcastGroupID).subscribe(data => {
      if (data) {
        this.podcastGroup = data;
        this.podcasts = this.podcastGroup.podcastPS;

      }
    })
  }

  routeDetail(id: number) {
    if (!this.isDesktop) {
      this.router.navigateByUrl('podcastDetail/' + id);
    }
  }

  ngOnDestroy() {
    if (this.routerSubs) {
      this.routerSubs.unsubscribe();
      this.routerSubs = null;
    }
  }




}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/views/podcast/podcast-grid/podcast-grid.component.ts